import contract, {selectors} from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'

import init from './init.js'

export default contract({
  [selectors]: {
    ':scope': array([
      init
    ])
  }
})
